import { useEffect, useRef, useState } from 'react';
import format from 'date-fns/format';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { onlyDigit, onlyNumber } from 'app/constants/regex';
import { schemaFilter } from 'app/components/Filter/schema';
import useCurrencySymbol from 'app/utils/customHooks/useCurrencySymbol';
import { useGetAccount } from 'app/utils/services/accountService';
import { usePaymentOptions } from 'app/constants/paymentOptions';
import dayjs from 'dayjs';

interface Props {
  selectedAccount?: string;
  paymentType?: any;
  btnId?: number;
  setPaymentType?: any;
  voen?: any;
  setVoen?: any;
  client?: any;
  setClient?: any;
  selectedPeriod?: any;
  setSelectedPeriod?: any;
  resNextDate?: any;
  setNextResDate?: any;
  resEndDate?: any;
  setEndResDate?: any;
  fromAmount?: any;
  setFromAmount?: any;
  toAmount?: any;
  setToAmount?: any;
  filterCounter?: number;
  setFilterCounter?: any;
  showCount?: any;
  setShowCount?: any;
  mainCount?: any;
  setMainCount?: any;
  showFilter?: any;
  setShowFilter?: any;
  isClean?: boolean;
  setIsClean?: any;
  resDate?: any;
  setResDate?: any;
  endDate?: any;
  setEndDate?: any;
  setPage: any;
  handleCheckData: (id: number) => void;
  filterTransactionMutation: any;
  accNo: string;
  setAccNo: (value: any) => void;
}

const useFilter = (props: Props) => {
  const {
    paymentType,
    btnId,
    setPaymentType,
    voen,
    setVoen,
    client,
    setClient,
    selectedPeriod,
    setSelectedPeriod,
    resNextDate,
    setNextResDate,
    resEndDate,
    setEndResDate,
    fromAmount,
    setFromAmount,
    toAmount,
    setToAmount,
    filterCounter,
    setFilterCounter,
    showCount,
    setShowCount,
    mainCount,
    setMainCount,
    showFilter,
    setShowFilter,
    isClean,
    setIsClean,
    resDate,
    setResDate,
    endDate,
    setEndDate,
    setPage,
    handleCheckData,
    filterTransactionMutation,
    accNo,
    setAccNo,
  } = props;
  const { t } = useTranslation();
  const [focused, setFocused] = useState(false);

  const paymentOptions = usePaymentOptions();

  const { dataGetAccount, isLoadingGetDataAccount } = useGetAccount();
  const accounts = dataGetAccount?.accounts?.map((item: any) => ({
    value: item.iban,
    label: `${item.emp_title} (${item.iban}) - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
    ...item,
  }));

  const period = [
    { value: '0', label: t('homePage.today') },
    { value: '1', label: t('homePage.currentMonth') },
    { value: '2', label: t('homePage.lastMonth') },
    { value: '12', label: t('homePage.year') },
    { value: '-1', label: t('homePage.range') },
  ];

  const resDateRef = useRef(null);

  const [firstFocused, setFirstFocused] = useState(false);
  const [secondFocused, setSecondFocused] = useState(false);
  const [nextDate] = useState(null);

  const smallScreen = useMediaQuery('(max-width: 1600px)');

  const onFocusNext = () => {
    setFirstFocused(true);
  };
  const onFocusEnd = () => {
    setSecondFocused(true);
  };

  const handlerBlur = () => {
    setFirstFocused(false);
    setSecondFocused(false);
  };

  const handlerNextDate = (startDate_: any) => {
    const isValid = dayjs(startDate_).isValid() && !dayjs(startDate_).isAfter(dayjs());
    setResDate(startDate_);
    isValid ? setNextResDate(dayjs(startDate_).format('DD-MM-YYYY')) : setNextResDate('');
    handlerBlur();
  };
  const handlerEndDate = (endDate_: any) => {
    const isValid = dayjs(endDate_).isValid() && !dayjs(endDate_).isAfter(dayjs());
    setEndDate(endDate_);
    isValid ? setEndResDate(dayjs(endDate_).format('DD-MM-YYYY')) : setEndResDate('');
    // isValid && setFilterCounter(filterCounter + 1);
    handlerBlur();
  };

  const onChangePeriod = (newValue: any) => {
    setSelectedPeriod(newValue);
    // if (selectedPeriod === null) {
    //   setFilterCounter(filterCounter - 1);
    // }
  };

  useEffect(() => {
    if (
      (paymentType !== null && Object.keys(paymentType).length > 0) ||
      client.length > 0 ||
      voen.length > 0 ||
      (selectedPeriod !== null && Object.keys(selectedPeriod).length > 0) ||
      (resDate !== null && resDate.length > 0) ||
      fromAmount.length > 0 ||
      toAmount.length > 0 ||
      resNextDate.length > 0 ||
      resEndDate.length > 0 ||
      accNo
    ) {
      setIsClean(true);
    } else {
      setIsClean(false);
    }
  }, [client, voen, resDate, paymentType, fromAmount, toAmount, selectedPeriod, resNextDate, resEndDate, accNo]);

  const onFocus = () => {
    setFocused(true);
  };

  const handleChangePaymentType = (newValue: any) => {
    setPaymentType(newValue);
    // if (paymentType === null) {
    //   setFilterCounter(filterCounter + 1);
    // }
  };

  const handleChangeClient = (event: any) => {
    setClient(event.target.value);

    // if (client.length === 0) {
    //   setFilterCounter(filterCounter + 1);
    // }
    //
    // if (event.target.value === '') {
    //   setFilterCounter(filterCounter - 1);
    // }
  };

  const handleChangeVoen = (event: any) => {
    if (event.target.value === '' || onlyNumber.test(event.target.value)) {
      setVoen(event.target.value);
    }
    // if (voen.length === 0) {
    //   setFilterCounter(filterCounter + 1);
    // }
    //
    // if (event.target.value === '') {
    //   setFilterCounter(filterCounter - 1);
    // }
  };

  const handlerChangeFromAmount = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = onlyDigit.test(event.target.value) ? event.target.value : '';
    setFromAmount(value);
    // if (!toAmount) {
    //   if(!value){
    //     setFilterCounter(filterCounter - 1);
    //   }
    //   setFilterCounter(filterCounter + 1);
    // }
  };

  const handlerChangeToAmount = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = onlyDigit.test(event.target.value) ? event.target.value : '';
    setToAmount(value);
    // if (!fromAmount) {
    //   if(!value){
    //     setFilterCounter(filterCounter - 1);
    //   }
    //   setFilterCounter(filterCounter + 1);
    // }
  };

  const handlerChangeDateInput = (event: any) => {
    setResDate(event.target.value);

    if (event.target.value === '') {
      // setFilterCounter(filterCounter - 1);
      // setStartDate(null);
      setEndDate(null);
    }
  };

  const resetAllInput = () => {
    setPage(1);

    filterTransactionMutation({
      acc_no: '',
      trn_type: '',
      end_date: '',
      start_date: '',
      period_type: 0,
      start_amount: '',
      end_amount: '',
      cr_custname: '',
      cr_taxno: '',
      search: '',
      db_cr_filter: btnId === 1 ? '' : btnId === 2 ? 'cr' : btnId === 3 && 'db',
      state: [],
    });

    setPaymentType(null);
    setClient('');
    setVoen('');
    setSelectedPeriod(null);
    setNextResDate('');
    setEndResDate('');
    setResDate(null);
    setEndDate(null);
    setFromAmount('');
    setToAmount('');
    setIsClean(false);
    setFilterCounter(0);
    setShowCount(false);
    setMainCount(0);
    setAccNo(null);
  };

  const resetWithRequest = async () => {
    await resetAllInput();
    handleCheckData(btnId);
  };

  const handleSubmitFilter = () => {
    if (filterCounter > 0) {
      setShowCount(true);
    } else {
      setShowCount(false);
    }
    setPage(1);

    handleCheckData(btnId);

    // setMainCount(filterCounter);
    setShowFilter(false);
  };

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schemaFilter), context: { voen } });

  return {
    t,
    options: paymentOptions,
    filterCounter,
    mainCount,
    setFilterCounter,
    showCount,
    setShowCount,
    showFilter,
    setShowFilter,
    paymentType,
    smallScreen,
    handleChangePaymentType,
    client,
    handleChangeClient,
    voen,
    handleChangeVoen,
    fromAmount,
    handlerChangeFromAmount,
    toAmount,
    handlerChangeToAmount,
    isClean,
    // resetAllInput,
    focused,
    // startDate,
    // endDate,
    resDate,
    handlerChangeDateInput,
    onFocus,
    // handlerBlur,
    // handlerDate,
    handleSubmitFilter,
    resDateRef,
    period,
    firstFocused,
    secondFocused,
    onFocusNext,
    onFocusEnd,
    handlerBlur,
    nextDate,
    endDate,
    resNextDate,
    resEndDate,
    handlerNextDate,
    handlerEndDate,
    onChangePeriod,
    selectedPeriod,
    control,
    register,
    errors,
    handleSubmit,
    resetAllInput,
    resetWithRequest,
    accounts,
    isLoadingGetDataAccount,
    setResDate,
    setEndDate,
  };
};

export default useFilter;
